import { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Button, ButtonGroup } from 'reactstrap';
// import '@logicamente.info/input-month-polyfill/dist/input-month-polyfill.min';
import Select from 'react-select';

import { URL_APPEND, reactSelectStyles } from '@general/constants';
import Loading from '@general/loading';
import SelectBill from './components/SelectBIll';
// import '../../App.css';

import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import localeData from 'dayjs/plugin/localeData'
dayjs.extend(advancedFormat)
dayjs.extend(localeData)

const BillReport = () => {
    const [data, setData] = useState([]);
    const [rptData, setRptData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    let [formData, setFormData] = useState({
        bill: '',
        month: '',
        year: '',
        stage: ''
    })
    let trackerUrl = `${URL_APPEND}/api/tracker/list`

    useEffect(() => {
        // setData(sampledata)
        axios.get(trackerUrl)
            .then(res => {
                let remapped = res.data.map(obj => ({
                    id: obj.uuid,
                    bill_id: obj.bill,
                    title: dayjs(obj.stage_date).format('MMMM Do, YYYY'),
                    stage_date: obj.stage_date,
                    stage: obj.stage,
                    cardSubtitle: obj.bill_name,
                    cardDetailedText: obj.details
                }))

                setData(remapped);
                setRptData(remapped);
                setIsLoading(false);

            })
            .catch(err => console.log(err));

    }, [])

    return isLoading ? <Loading /> : (
        <>

            {/* <br /> */}

            <div style={{ display: 'flex', flexFlow: 'row wrap', alignContent: 'space-between' }}>
                <h4 outline>Filter By: </h4>&nbsp;

                <SelectBill
                    onChange={sel => {
                        setRptData(rptData.filter(el => el.bill_id == sel.value))
                        setFormData({ bill: sel })
                    }}
                    value={formData?.bill}
                /> &nbsp;

                <Select
                    menuPortalTarget={document.querySelector('body')}
                    styles={reactSelectStyles}
                    placeholder='Month'
                    options={dayjs.monthsShort().map(m => ({ label: m, value: m }))}
                    onChange={sel => {
                        setFormData({ month: sel })
                        setRptData(rptData.filter(el => dayjs(el.stage_date).format('MMM') == sel.value))
                    }
                    }
                    value={formData?.month}
                /> &nbsp;

                <Select
                    menuPortalTarget={document.querySelector('body')}
                    styles={reactSelectStyles}
                    placeholder='Year'
                    options={
                        [...Array(dayjs(dayjs()).diff('2016-01-01', 'year')).keys()]
                            .map(yr => 2016 + yr + 1)
                            .map(yr => yr.toString())
                            .map(y => ({ label: y, value: y }))
                    }
                    onChange={sel => {
                        setFormData({ year: sel })
                        setRptData(rptData.filter(el => dayjs(el.stage_date).format('YYYY') == sel.value))
                    }
                    }
                    value={formData?.year}
                /> &nbsp;

                <Select
                    menuPortalTarget={document.querySelector('body')}
                    styles={reactSelectStyles}
                    placeholder='Stage...'
                    options={
                        ['First reading',
                            'Second reading',
                            'Committee Stage',
                            'Third Reading',
                            'Presidential Assent',
                            'Passed On'
                        ].map(el => ({ value: el, label: el }))
                    }
                    onChange={sel => {
                        setFormData({ stage: sel })
                        setRptData(rptData.filter(el => el.stage == sel.value))
                    }}
                    value={formData?.stage}
                /> &nbsp;&nbsp;&nbsp;

                <ButtonGroup style={{ marginLeft: '50px' }}>
                    <Button disabled={rptData == data} color='danger' size='sm' onClick={() => {
                        setRptData(data);
                        setFormData({
                            ...formData,
                            bill: '',
                            month: '',
                            year: '',
                            stage: ''
                        })

                    }}>Reset</Button>

                    <Button color='danger' size='sm' onClick={() => {
                        var mywindow = window.open('', 'my div', 'height=400,width=1200');
                        var printprevtimeout = 1000;
                        var header = '<html><head><title>Bills Report</title>';
                        // header += '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css" integrity="sha384-TX8t27EcRE3e/ihU7zmQxVncDAy5uIKz4rEkgIXeMed4M0jlfIDPvg6uqKI2xXr2" crossorigin="anonymous">';
                        header += '<link rel="stylesheet" href="/static/dist/css/dokeza.css">'
                        mywindow.document.write(header);

                        mywindow.document.write('</head><body><div class="container-fluid">');
                        mywindow.document.write(document.getElementById('rpt').innerHTML);
                        mywindow.document.write('</div></body></html>');
                        mywindow.document.close();
                        setTimeout(function () {
                            mywindow.print();
                        }, printprevtimeout);
                    }}>
                        <i className="fa fa-print" aria-hidden="true"></i> Print
                    </Button>
                </ButtonGroup>

            </div>
            <br />
            <div id='rpt'>
                {/* <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous" /> */}
                <link rel="stylesheet" href="/static/dist/css/dokeza.css"></link>

                <Table hover bordered>
                    <thead>

                        <tr>
                            <th>Date</th>
                            <th>Stage</th>
                            <th>Bill</th>
                            <th>Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rptData && rptData.map(b => {
                            return <tr key={b.id}>
                                <td>{b.title}</td>
                                <td>{b.stage}</td>
                                <td>{b.cardSubtitle}</td>
                                <td>{b.cardDetailedText}</td>
                            </tr>
                        })}

                    </tbody>
                </Table>

            </div>
        </>
    )
}

export default BillReport;